import { fetcher } from "helpers/fetcher";

import { TGetClientPostRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getClientPost = async (language: string) => {
  return await fetcher<TGetClientPostRes, any>(ENDPOINT.USER.GET_CLIENT_POST, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.GET_CLIENT_POST.version,
      [API_HEADER.LANGUAGE]: language,
    },
  });
};

export const queryGetClientPost = async (language: string) => {
  return (await getClientPost(language)).data;
};

queryGetClientPost._key = (language: string) => [
  ENDPOINT.USER.GET_CLIENT_POST.url,
  language,
];
